import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

// Mesma faixa do TicketHeader (padrão do WhatsApp Web), para não "pular" quando a conversa carrega.
const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		alignItems: "center",
		gap: 12,
		flex: "none",
		height: 59,
		minHeight: 59,
		padding: "0 16px",
		background: theme.palette.type === "dark" ? "#202c33" : "#f0f2f5",
		[theme.breakpoints.down("sm")]: {
			height: 56,
			minHeight: 56,
			padding: "0 12px",
		},
		"& .MuiSkeleton-root": {
			backgroundColor: theme.palette.type === "dark" ? "rgba(233,237,239,0.1)" : "rgba(11,20,26,0.09)",
		},
	},
	texts: {
		display: "flex",
		flexDirection: "column",
		gap: 7,
	},
	line: {
		borderRadius: 6,
	},
}));

const TicketHeaderSkeleton = () => {
	const classes = useStyles();

	return (
		<div className={classes.ticketHeader} aria-busy="true">
			<Skeleton animation="wave" variant="circle" width={36} height={36} />
			<div className={classes.texts}>
				<Skeleton animation="wave" variant="rect" width={140} height={12} className={classes.line} />
				<Skeleton animation="wave" variant="rect" width={90} height={10} className={classes.line} />
			</div>
		</div>
	);
};

export default TicketHeaderSkeleton;
